import { render, staticRenderFns } from "./TutorialVideos.vue?vue&type=template&id=075aae50&scoped=true&lang=pug&"
import script from "./TutorialVideos.vue?vue&type=script&lang=js&"
export * from "./TutorialVideos.vue?vue&type=script&lang=js&"
import style0 from "./TutorialVideos.vue?vue&type=style&index=0&id=075aae50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075aae50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('075aae50')) {
      api.createRecord('075aae50', component.options)
    } else {
      api.reload('075aae50', component.options)
    }
    module.hot.accept("./TutorialVideos.vue?vue&type=template&id=075aae50&scoped=true&lang=pug&", function () {
      api.rerender('075aae50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/TutorialVideos.vue"
export default component.exports